export default __webpack_public_path__ + "empty-variables-md.20df011e.svg";